// react imports
import React, { useContext, useState, useEffect } from "react";
import { Outlet, useSearchParams, useNavigate } from "react-router-dom";

import AppContext from "../AppContext";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import NewsModal from "../modals/NewsModal";

// MDBOOTSTRAP IMPORTS
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBSideNav,
  MDBSideNavMenu,
  MDBSideNavItem,
  MDBSideNavLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBSideNavCollapse,
  MDBIcon,
  MDBBtn,
  MDBRow,
  MDBInput,
  MDBCol,
} from "mdb-react-ui-kit";

// IMPORT LAYOUT COMPONENTS

import Cookies from "universal-cookie";
const cookies = new Cookies();

function Layout({ children }) {
  const context = useContext(AppContext);

  // STATES
  const [basicOpen, setBasicOpen] = useState(false);
  const [basicCollapse1, setBasicCollapse1] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // react router navigation
  const navigate = useNavigate();

  const scrollEventListener = () => {
    if (window.scrollY < 50) {
      setIsScrolling(false);
    } else {
      setIsScrolling(true);
    }
  };

  useEffect(() => {
    context.interAxios.get("/news", function (response) {
      if (response.data.active) {
        if (
          cookies.get("news")?.timestamp !== response.data.createdAt ||
          (response.data.createdAt + 2 * 24 * 60 * 60) * 1000 < new Date().getTime()
        ) {
          context.openModal("news");
        }
      }
    });
  }, []);

  useEffect(() => {
    document.addEventListener("scroll", scrollEventListener);

    return () => {
      document.removeEventListener("scroll", scrollEventListener);
    };
  }, []);

  return (
    <>
      <MDBContainer className="project-container">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        {context.getState()?.modalName === "news" && (
          <NewsModal
            visible={context.getState()?.loginModalOpened}
            hideModal={() => {
              context.closeModal();
              context.onSetActiveItem("1");
            }}
            openModal={context.openModal}
            context={context}
          />
        )}
      </MDBContainer>
    </>
  );
}

export default Layout;
